/** Selectors for portal'd UI that may be opened from inside an exercise
 * editor (rc-dropdown menus, ReactModal-based modals, react-tooltip,
 * react-select menus). Two consumers:
 *  - MonthEditPopover's outside-click check — clicks on these must NOT
 *    close the popover, since they're interactions it spawned itself.
 *  - useEnterSavesForm — Enter inside these belongs to the portal'd
 *    widget (picking an option, confirming a modal), not to SAVE.
 * The [class*="__menu"] entry catches react-select's menu
 * portal/list/etc. regardless of classNamePrefix — options are always
 * descendants of the menu, so `closest()` finds the menu ancestor. */
const PORTAL_SELECTORS = [
  '.rc-dropdown',
  '.rc-trigger-popup',
  '.ReactModal__Overlay',
  '.ReactModal__Content',
  '.ReactModalPortal',
  '.react-tooltip',
  '[class*="__menu"]',
  /* 3-dot submenu popups (superset picker, pace picker) portal to body
   * with their own class names — not inside .rc-dropdown — so they
   * need explicit entries or clicking a color/pace closes the popover. */
  '.custom-submenu-supersetPicker',
  '.pace-dropdown',
  '.nested-submenu',
  /* Transposed add-exercise table's set-number superset picker also
   * portals to body with its own class — without this, choosing a
   * superset letter would close the popover. */
  '.transposed-superset-popover',
].join(',');

export default PORTAL_SELECTORS;
